import { Outlet, NavLink } from "react-router-dom";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import WrapLayoutSocialIcons from "../components/SocialIcons/WrapLayoutSocialIcons";


export default function MainLayout() {
    return (
        <div className="app-container">
            <Header />

            {/* 2. Phần nội dung thay đổi (Outlet) */}
            <main>
                <Outlet />
            </main>
        <WrapLayoutSocialIcons/>
        <Footer/>
        </div>
    );
}